exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topic-sidebar .active {\n  border-left: 5px solid #008cba;\n  color: #00526e; }\n\n.topic-sidebar > p {\n  padding: 0px 10px;\n  border-left: 5px solid white; }\n  .topic-sidebar > p:hover {\n    cursor: pointer; }\n", ""]);

// exports
